/* CCS 2026 Design: Aureal homepage motion + gift finder. No moving-media files; nothing rotates on its own.
   All motion is skipped under prefers-reduced-motion. Smoke and embers finish 4 s after the hero image loads.
   Reveal only tags blocks that start below the fold (never the H1); parallax and lift are transform-only. */
(function(){
'use strict';
if(window.ccsHome)return;window.ccsHome=1;
var D=document,R=D.documentElement;
R.classList.add('ccs-js');
var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
function qsa(s,c){return Array.prototype.slice.call((c||D).querySelectorAll(s));}

/* hero smoke + embers (decorative canvas, aria-hidden, runs once) */
function hero(h){
 if(RM||h.dataset.ccsDone)return; h.dataset.ccsDone=1;
 var cv=h.querySelector('canvas'),img=h.querySelector('.ccs-hero__media img');
 if(!cv||!img||!cv.getContext)return;
 var ctx=cv.getContext('2d'),W=0,H=0,dpr=Math.min(2,window.devicePixelRatio||1);
 function pc(v,d){return v===''||v==null||isNaN(+v)?d:+v/100;}var sxd=pc(h.dataset.sxD,.295),sxm=pc(h.dataset.sxM,.354),sy=pc(h.dataset.sy,.3);
 var puff=D.createElement('canvas');puff.width=puff.height=128;
 var g0=puff.getContext('2d'),gr=g0.createRadialGradient(64,64,0,64,64,64);
 gr.addColorStop(0,'rgba(240,232,220,.55)');gr.addColorStop(.45,'rgba(225,215,200,.22)');gr.addColorStop(1,'rgba(220,210,195,0)');
 g0.fillStyle=gr;g0.fillRect(0,0,128,128);
 function mob(){return innerWidth<=960;}
 function size(){var r=h.getBoundingClientRect();W=r.width;H=r.height;cv.width=W*dpr;cv.height=H*dpr;ctx.setTransform(dpr,0,0,dpr,0,0);}
 function chimney(){
  var hr=h.getBoundingClientRect(),ir=img.getBoundingClientRect(),bw=img.offsetWidth,bh=img.offsetHeight;
  var nw=img.naturalWidth||1000,nh=img.naturalHeight||801,s=Math.max(bw/nw,bh/nh),dw=nw*s,dh=nh*s;
  var op=getComputedStyle(img).objectPosition.split(' ').map(function(v){return parseFloat(v)/100;});
  var ox=ir.left-hr.left+(bw-dw)*op[0],oy=ir.top-hr.top+(bh-dh)*op[1];
  return {x:ox+dw*(mob()?sxm:sxd),y:oy+dh*sy,s:s};
 }
 var parts=[],embers=[],t0=0,t=0,SPAWN_END=2200,FADE_START=2900,END=4000;
 function smoke(){var c=chimney();parts.push({x:c.x+(Math.random()-.5)*6*c.s,y:c.y,vx:.2+Math.random()*.25,vy:-(.7+Math.random()*.5),r:6*c.s+Math.random()*6,g:.16+Math.random()*.08,life:0,max:110+Math.random()*60,a:.3+Math.random()*.2,ph:Math.random()*6});}
 function ember(){
  var ir=img.getBoundingClientRect(),hr=h.getBoundingClientRect(),x,y;
  if(mob()){x=W*(.55+Math.random()*.45);y=ir.top-hr.top+img.offsetHeight*(.6+Math.random()*.3);}
  else{x=ir.left-hr.left+img.offsetWidth*(.55+Math.random()*.4);y=H*.55+Math.random()*H*.35;}
  embers.push({x:x,y:y,vx:(Math.random()-.5)*.4,vy:-(.5+Math.random()*1.1),r:.8+Math.random()*1.8,life:0,max:90+Math.random()*90,ph:Math.random()*6});
 }
 function step(el){
  t++;var i,p,k,fade=el<FADE_START?1:Math.max(0,1-(el-FADE_START)/(END-FADE_START));
  ctx.clearRect(0,0,W,H);
  for(i=parts.length-1;i>=0;i--){p=parts[i];p.life++;k=p.life/p.max;if(k>=1){parts.splice(i,1);continue;}
   p.x+=p.vx+Math.sin(p.ph+p.life*.03)*.35;p.y+=p.vy;p.r+=p.g;
   ctx.globalAlpha=Math.min(1,p.life/20)*(1-k)*(1-k)*p.a*fade;ctx.drawImage(puff,p.x-p.r,p.y-p.r,p.r*2,p.r*2);}
  ctx.globalCompositeOperation='lighter';
  for(i=embers.length-1;i>=0;i--){p=embers[i];p.life++;k=p.life/p.max;if(k>=1){embers.splice(i,1);continue;}
   p.x+=p.vx+Math.sin(p.ph+p.life*.05)*.4;p.y+=p.vy;
   ctx.globalAlpha=(1-k)*(.6+.4*Math.sin(p.life*.3+p.ph))*.9*fade;
   var g=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,p.r*5);g.addColorStop(0,'rgba(255,200,120,1)');g.addColorStop(.3,'rgba(255,130,40,.6)');g.addColorStop(1,'rgba(255,90,20,0)');
   ctx.fillStyle=g;ctx.beginPath();ctx.arc(p.x,p.y,p.r*5,0,7);ctx.fill();}
  ctx.globalCompositeOperation='source-over';ctx.globalAlpha=1;
 }
 var raf=0,HARD=4800;/* hard stop: smoke is gone by 4.8s after navigation, whatever the image load time */
 function loop(now){
  if(!t0){t0=now;var room=HARD-now;if(room<END){var k=Math.max(0,room)/END;SPAWN_END*=k;FADE_START*=k;END=Math.max(0,room);}}
  var el=now-t0;
  if(el<SPAWN_END){if(t%2===0)smoke();if(t%6===0)ember();}
  step(el);
  if(el<END&&now<HARD)raf=requestAnimationFrame(loop);else{cancelAnimationFrame(raf);ctx.clearRect(0,0,W,H);parts.length=embers.length=0;removeEventListener('resize',size);}
 }
 size();addEventListener('resize',size);
 function go(){if(performance.now()<HARD-1300)raf=requestAnimationFrame(loop);else removeEventListener('resize',size);}
 if(img.complete&&img.naturalWidth)go();else img.addEventListener('load',go,{once:true});
}

/* map arcs draw in once when scrolled into view */
function map(svg){
 if(RM||!('IntersectionObserver' in window)){svg.classList.add('is-in');return;}
 var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){svg.classList.add('is-in');io.disconnect();}});},{threshold:.3});
 io.observe(svg);
}

/* reveal tagging runs in two passes so the page lays out once: collect candidates, measure all, then mutate all (no read/write interleave) */
function rvTag(el,d,q){
 if(el.classList.contains('scroll-trigger')||el.querySelector('.scroll-trigger')||el.classList.contains('ccs-rv'))return;
 q.push([el,d]);
}
function rvUnits(block,h,q){/* every element that does not contain the heading becomes its own unit */
 var after=false;
 (function walk(n){Array.prototype.slice.call(n.children).forEach(function(c){
  if(c===h){after=true;return;}
  if(c.contains(h)){walk(c);return;}
  rvTag(c,after?'300ms':'',q);
 });})(block);
}
/* scroll reveal: blocks below the fold fade up once (IntersectionObserver); first-screen content is never hidden */
var rvIO=null;
function reveal(sec,q){
 if(RM||!('IntersectionObserver' in window))return;
 qsa('.ccs-wrap > *',sec).forEach(function(el){
  var w=el.matches('[data-ccs-words]')?el:el.querySelector('[data-ccs-words]');
  if(w){if(w!==el)rvUnits(el,w,q);return;}
  rvTag(el,'',q);
 });
}
function rvFlush(q){
 if(!q.length)return;
 if(!rvIO)rvIO=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');rvIO.unobserve(e.target);}});},{threshold:.1,rootMargin:'0px 0px -6% 0px'});
 var vh=innerHeight,tops=q.map(function(x){return x[0].getBoundingClientRect().top;});/* read pass */
 q.forEach(function(x,i){if(tops[i]<vh)return;if(x[1])x[0].style.transitionDelay=x[1];x[0].classList.add('ccs-rv');rvIO.observe(x[0]);});/* write pass */
}

/* Cut / Dried / Lit numerals: gentle parallax, desktop only, transform only, one rAF per scroll */
function parallax(){
 var els=qsa('.ccs-tstep__num');
 if(RM||!els.length||!matchMedia('(min-width:961px)').matches)return;
 var ticking=false;
 function upd(){ticking=false;var vh=innerHeight,ys=els.map(function(el){var r=el.parentNode.getBoundingClientRect();return Math.max(-1,Math.min(1,(r.top+r.height/2-vh/2)/vh));});
  els.forEach(function(el,i){el.style.transform='translate3d(0,'+(ys[i]*-22).toFixed(1)+'px,0)';});}
 addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(upd);}},{passive:true});
 upd();
}

/* gift finder: filter the merchant's gift pool by budget, rank by 'who', show 3 */
function finder(f){
 if(f.dataset.ccsReady)return;f.dataset.ccsReady=1;
 var grid=f.querySelector('[data-ccs-cards]'),cards=qsa('.ccs-card',grid),title=f.querySelector('[data-ccs-title]');
 var empty=f.querySelector('[data-ccs-empty]'),tpl=f.dataset.titleTpl||'',n=+f.dataset.count||3;
 var st={};
 qsa('.ccs-chip[aria-pressed="true"]',f).forEach(function(c){st[c.dataset.k]=c;});
 function txt(s){return D.createTextNode(s);}
 function render(){
  var w=st.who,b=st.budget,o=st.occ,min=b?+b.dataset.min:0,max=b?+b.dataset.max:0,wid=w?w.dataset.v:'';
  var list=cards.filter(function(c){var p=+c.dataset.price;return (!b)||(p>=min&&(!max||p<max));});
  list.sort(function(a,c){var x=(' '+a.dataset.who+' ').indexOf(' '+wid+' ')>-1?0:1,y=(' '+c.dataset.who+' ').indexOf(' '+wid+' ')>-1?0:1;return x-y||(+a.dataset.rank)-(+c.dataset.rank);});
  list=list.slice(0,n);
  cards.forEach(function(c){c.hidden=list.indexOf(c)<0;});
  list.forEach(function(c){grid.appendChild(c);});
  if(empty)empty.hidden=list.length>0;
  if(title&&tpl){
   title.textContent='';
   tpl.split(/(\[who\]|\[budget\])/).forEach(function(part){
    if(part==='[who]'){var em=D.createElement('em');em.textContent=w?w.dataset.title:'';title.appendChild(em);}
    else if(part==='[budget]')title.appendChild(txt(b?b.dataset.title:''));
    else title.appendChild(txt(part));
   });
  }
  qsa('[data-ccs-note]',f).forEach(function(el){el.hidden=!(w&&el.dataset.ccsNote===w.dataset.v)&&!(o&&el.dataset.ccsNote===o.dataset.v);});
 }
 f.addEventListener('click',function(e){
  var c=e.target.closest&&e.target.closest('.ccs-chip');if(!c||!f.contains(c))return;
  qsa('.ccs-chip[data-k="'+c.dataset.k+'"]',f).forEach(function(x){x.setAttribute('aria-pressed',x===c?'true':'false');});
  st[c.dataset.k]=c;render();
 });
 render();
}

function init(root){
 root=root||D;
 qsa('.ccs-hero',root).forEach(hero);
 qsa('.ccs-map__svg',root).forEach(map);
 qsa('[data-ccs-finder]',root).forEach(finder);
 var q=[];qsa('.ccs:not(.ccs-hero)',root).forEach(function(sec){reveal(sec,q);});rvFlush(q);
}
if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',function(){init();parallax();});else{init();parallax();}
/* theme editor: re-run when a ccs section is added or changed */
D.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
